module.exports = __webpack_public_path__ + "img/laptop.26a282d8.svg";